module.exports = __webpack_public_path__ + "img/brain-logo.090792b4.png";